import { defineComponent, computed } from 'vue';
import { UiMessagePropsOption } from './message.mjs';
import { UiIcon } from '../../../components/icon/index.mjs';

var _sfc_main = defineComponent({
  name: "UiMessage",
  props: UiMessagePropsOption,
  components: { UiIcon },
  setup(define) {
    return {
      className: computed(() => `ui-${define.type}-type`),
      styles: computed(() => {
        return {
          transform: `translateY(${define.offset}px)`
        };
      })
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=message.vue2.mjs.map
